import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const textarea = tv({
  base: `
    border-input
    placeholder:text-muted-foreground
    aria-invalid:ring-destructive/20
    dark:aria-invalid:ring-destructive/40
    aria-invalid:border-destructive
    dark:bg-input/30
    focus-visible:ring-content-primary
    flex
    field-sizing-content
    min-h-16
    w-full
    rounded-md
    border
    bg-transparent
    px-3
    py-2
    text-base
    shadow-xs
    transition-[color,box-shadow]
    outline-none
    focus-visible:ring-1
    focus-visible:ring-offset-1
    disabled:cursor-not-allowed
    disabled:opacity-50
    md:text-sm
  `
});
type TextareaProps = React.ComponentProps<'textarea'> & VariantProps<typeof textarea>;
function Textarea(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = textarea({
      className
    });
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <textarea className={t1} data-slot="textarea" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { textarea, Textarea, type TextareaProps };